import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { urls, copy, currentLang } from "../../shared/seo/links";
import { useLawyerContext } from "../../shared/context/LawyerContext";
import { lawyerGovernorate, lawyerName, lawyerProfileUrl } from "./lawyerHelpers";
import "./lawyers.css";

// "Other lawyers in Sfax": links between profiles of the same governorate.
export default function OtherLawyers({ lawyer }) {
  const { t } = useTranslation();
  const lang = currentLang();
  const { getLawyersDirectory } = useLawyerContext();
  const [others, setOthers] = useState([]);
  const governorate = lawyerGovernorate(lawyer);
  const govKey = governorate ? governorate.key : null;

  useEffect(() => {
    if (!govKey) return undefined;
    let cancelled = false;
    async function fetchOthers() {
      const res = await getLawyersDirectory({
        governorate: govKey,
        excludeId: lawyer.id,
        pageSize: 8,
      });
      if (!cancelled) setOthers(res.data?.data ?? []);
    }
    fetchOthers();
    return () => {
      cancelled = true;
    };
    // getLawyersDirectory is recreated on every provider render: left out.
  }, [govKey, lawyer.id]);

  if (!governorate || others.length === 0) return null;
  const city = urls.governorateName(governorate, lang);
  return (
    <div className="avc-sidebar-card avc-other-lawyers">
      <h2 className="avc-sidebar-card__title">{t("profile_other_lawyers", { city })}</h2>
      <ul>
        {others.map((other) => {
          const level = urls.findBarLevel(other.barLevel);
          return (
            <li key={other.id}>
              <PathLink to={lawyerProfileUrl(other, lang)}>{lawyerName(other, lang)}</PathLink>
              {level && <small>{level[lang]}</small>}
            </li>
          );
        })}
      </ul>
      <PathLink to={urls.lawyersPath(lang, { governorate })} className="avc-other-lawyers__all">
        {copy.lawyers(lang, { governorate }).h1}
        <i className={lang === "ar" ? "fas fa-arrow-left" : "fas fa-arrow-right"} aria-hidden="true"></i>
      </PathLink>
    </div>
  );
}
